import { RouteObject } from 'react-router-dom';
import { routes } from '../../routes';
import CheckoutPage from './CheckoutPage';
import SuccessPurchasePage from '../purchase/SuccessPurchasePage';

export const checkoutRoutes: RouteObject[] = [
    { path: routes.CHECKOUT, element: <CheckoutPage /> },
    { path: routes.CHECKOUT_SUCCESS, element: <SuccessPurchasePage />},
    { path: routes.CHECKOUT_CANCEL, element: <SuccessPurchasePage />},
];
